import { render } from "./AskForQuoteComment.vue?vue&type=template&id=1b5131be"
import script from "./AskForQuoteComment.vue?vue&type=script&lang=js"
export * from "./AskForQuoteComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__